<template>
  <div>
    <navigation/>
    <div class="pale-bgcolor">
      <div class="ay_contain">
        <div class="ay_title">
          亮照变更
        </div>
        <form id="applyForm">
          <input id="siteBaseId" name="siteBaseId" type="hidden">
          <div class="ay_userinfo ay_user">
            <div class="ayui_list">
              <br/>
              <div class="ayui_item">
                <label>网站名称</label>
                <input type="text" name="beforeContent_0" id="beforeContent_0" disabled v-model="siteBaseInfo.siteName">
                <input type="button" style="width: 48px;" value="变更" @click="changeInfo_0('open');"/>
              </div>
              <div class="ayui_item" style="display: none;" id="siteNameChange">
                <label style="color: #0e90d2;">变更为</label>
                <input type="text" name="afterContent_0" id="afterContent_0" v-model="changeSiteBaseInfo.siteName">
                <input name="changeField_0" type="hidden" value="siteName">
                <span class="iconfont icon-cancle ca_icon_close" @click="changeInfo_0('close');"></span>
              </div>

              <div class="ayui_item">
                <label>企业名称</label>
                <input type="text" id="beforeContent_1" name="beforeContent_1" disabled v-model="siteBaseInfo.companyName">
                <input type="button" style="width: 48px;" value="变更" @click="changeInfo_1('open');"/>
              </div>
              <div class="ayui_item" style="display: none;" id="companyNameChange">
                <label style="color: #0e90d2;">变更为</label>
                <input type="text" name="afterContent_1" id="afterContent_1" v-model="changeSiteBaseInfo.companyName">
                <input name="changeField_1" type="hidden" value="companyName">
                <span class="iconfont icon-cancle ca_icon_close" @click="changeInfo_1('close');"></span>
              </div>

              <div class="ayui_item">
                <label>网站类型</label>
                <input id="beforeContent_2" name="beforeContent_2" type="hidden" v-model="siteBaseInfo.siteType">
                <input v-if="siteBaseInfo.siteType == 1" type="text" value="独立交易网站" disabled>
                <input v-if="siteBaseInfo.siteType == 5" type="text" value="独立非交易网站" disabled>
                <input v-if="siteBaseInfo.siteType == 4" type="text" value="交易平台" disabled>
                <input v-if="siteBaseInfo.siteType == 2" type="text" value="辖区内平台网店" disabled>
                <input v-if="siteBaseInfo.siteType == 3" type="text" value="辖区外平台网店" disabled>
                <input type="button" style="width: 48px;" value="变更" @click="changeInfo_2('open');"/>
              </div>
              <div class="ayui_item" style="display: none;" id="siteTypeChange">
                <label style="color: #0e90d2;">变更为</label>
                <select id="afterContent_2" name="afterContent_2" v-model="changeSiteBaseInfo.siteType">
                  <option value="">--请选择--</option>
                  <option value="1">独立交易网站</option>
                  <option value="5">独立非交易网站</option>
                  <option value="4">交易平台</option>
                  <option value="2">辖区内平台网店</option>
                  <option value="3">辖区外平台网店</option>
                </select>
                <input name="changeField_2" type="hidden" value="siteType">
                <span class="iconfont icon-cancle ca_icon_close" @click="changeInfo_2('close');"></span>
              </div>

              <div class="ayui_item">
                <label>姓名</label>
                <input type="text" name="beforeContent_3" id="beforeContent_3"
                       disabled v-model="siteBaseInfo.applyName">
                <input type="button" style="width: 48px;" value="变更" @click="changeInfo_3('open');"/>
              </div>
              <div class="ayui_item" style="display: none;" id="applyNameChange">
                <label style="color: #0e90d2;">变更为</label>
                <input type="text" name="afterContent_3" id="afterContent_3" v-model="changeSiteBaseInfo.applyName">
                <input name="changeField_3" type="hidden" value="applyName">
                <span class="iconfont icon-cancle ca_icon_close" @click="changeInfo_3('close');"></span>
              </div>

              <div class="ayui_item">
                <label>邮箱</label>
                <input type="text" name="beforeContent_4" id="beforeContent_4"
                       disabled v-model="siteBaseInfo.applyEmail">
                <input type="button" style="width: 48px;" value="变更" @click="changeInfo_4('open');"/>
              </div>
              <div class="ayui_item" style="display: none;" id="applyEmailChange">
                <label style="color: #0e90d2;">变更为</label>
                <input type="text" name="afterContent_4" id="afterContent_4" v-model="changeSiteBaseInfo.applyEmail">
                <input name="changeField_4" type="hidden" value="applyEmail" placeholder="请输入正确的邮箱">
                <span class="iconfont icon-cancle ca_icon_close" @click="changeInfo_4('close');"></span>
              </div>

              <div class="ayui_item">
                <label>电话</label>
                <!-- <input type="text" name="applyPhone" id="applyPhone" value="${siteBaseInfo.applyPhone}" onmouseout="getEvent();"> -->
                <input type="text" name="beforeContent_5" id="beforeContent_5"
                       disabled v-model="siteBaseInfo.applyPhone">
                <input type="button" style="width: 48px;" value="变更" @click="changeInfo_5('open');"/>
              </div>
              <div class="ayui_item" style="display: none;" id="applyPhoneChange">
                <label style="color: #0e90d2;">变更为</label>
                <input type="text" name="afterContent_5" id="afterContent_5"  v-model="changeSiteBaseInfo.applyPhone">
                <input name="changeField_5" type="hidden" value="applyPhone" placeholder="请输入正确的手机">
                <span class="iconfont icon-cancle ca_icon_close" @click="changeInfo_5('close');"></span>
              </div>

              <div class="ayui_item ayui_vail" style="display: none;" id="getAuthCode">
                <label>手机验证码</label>
                <input type="text" name="authCode" id="authCode" v-model="changeSiteBaseInfo.code">
                <!--<a href="javascript:setPhone();" class="rg-vali-title send_num"
                   style="background-color:#1E9FFF">获得验证码</a>-->
                <span class="rg-vali-title send_num" id="sendButton" @click="sendPhone"><span v-if="isSend" style="background:rgba(0,0,0,0) none repeat scroll !important;">{{
                    downCount
                  }}</span>{{ sendMsg }}</span>
              </div>

              <div style="clear: both;"></div>
            </div>
          </div>
          <!-- <input type="button" id="apply_submit" style="width: 120px;margin-left: 420px;" class="rg_botton" value="确定"/> -->
          <!-- <input type="button" id="submitForm" style="width: 120px;margin-left: 420px;" class="rg_botton" value="确定" onClick="commitInfo();"/> -->
          <input type="button" id="submitForm" @click="submit" style="width: 120px;margin-left: 420px;" class="rg_botton" value="确定"/>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import navigation from './navigation'

export default {
  name: 'changeSite',
  components: {
    'navigation': navigation
  },
  data() {
    return {
      siteBaseId: null,
      sendMsg: '发送验证码',
      downCount: 60,
      isSend: false,
      changeSiteBaseInfo: {
        siteBaseId: null,
        code: null,
        siteName: null,
        companyName: null,
        siteType: null,
        applyName: null,
        applyEmail: null,
        applyPhone: null,
      },
      siteBaseInfo: {
        siteTypeStr: null,
        domainItems: null,
        verCode: null,
        siteBaseId: null,
        companyName: null,
        companyLegalPerson: null,
        companyNumber: null,
        companyType: null,
        companyRegisterMoney: null,
        companyCreateTime: null,
        registerOffice: null,
        operateTimeStart: null,
        operateTimeEnd: null,
        address: null,
        operateScope: null,
        siteType: null,
        siteDomain: null,
        siteName: null,
        siteDescription: null,
        orgId: null,
        applyStatus: null,
        description: null,
        isOwned: null,
        ownerOrg: null,
        ownerOrgCode: null,
        dealType: null,
        applyPhone: null,
        applyName: null,
        clientUserId: null,
        applyEmail: null
      }
    }
  },
  watch: {
    $route: function (route) {
      this.dataList(this, 1)
    }
  },
  created: function () {
    this.siteBaseId = parseInt(this.$route.params.siteBaseId)
    this.changeSiteBaseInfo.siteBaseId = this.siteBaseId
    this.getSiteBaseInfo(this.siteBaseId)
  },
  methods: {
  /**
   * 点击发送邮件
   */
  sendPhone() {
    if (this.changeSiteBaseInfo.applyPhone == null) {
      this.$message.warning('请填写手机号!')
      return
    }
    var reg = /^1\d{10}$/
    if (!reg.test(this.changeSiteBaseInfo.applyPhone)) {
      this.$message.warning('手机号格式错误, 无法发送!')
      return
    }
    if (this.isSend) {
      return
    }
    let _self = this
    _self.axios.get(
      _self.api.sendPhoneCode + '?phone=' + this.changeSiteBaseInfo.applyPhone
    ).then(res => {
      if (res.data.code === 10001) {
        this.toIndex()
      } else if (res.data.code === 10000) {
        this.$message.success('发送成功!')
        this.isSend = true
        this.downCount = 60
        var button = document.getElementById("sendButton");
        button.setAttribute("style", "background-color:#ccc");
        this.isSend = true
        this.sendMsg = '秒后重试'
        this.timer = setInterval(() => {
          this.downCount = this.downCount - 1
          if (this.downCount <= 0) {
            button.setAttribute("style", "background-color:#5289e2");
            this.sendMsg = '发送验证码'
            this.isSend = false
          }
        }, 1000)
      } else {
        this.$message.error(res.data.message)
      }
    }).catch(err => {
      this.$message.error('网络请求异常!')
    })
  },
    submit() {
      var reg = /^1\d{10}$/
      if (this.changeSiteBaseInfo.applyPhone != null && this.changeSiteBaseInfo.applyPhone !== '' && !reg.test(this.changeSiteBaseInfo.applyPhone)) {
        this.$message.warning('手机号格式错误!')
        return
      }
      var verify = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
      if (this.changeSiteBaseInfo.applyEmail != null && this.changeSiteBaseInfo.applyEmail !== '' && !verify.test(this.changeSiteBaseInfo.applyEmail)) {
        this.$message.warning('邮箱格式错误!')
        return
      }
    if (this.changeSiteBaseInfo.applyPhone !== null && this.changeSiteBaseInfo.code == null) {
      this.$message.warning('请填写验证码!')
      return
    }
      let _self = this
      _self.axios.post(
        _self.api.changeApply,this.changeSiteBaseInfo
      ).then(res => {
        if ((typeof res) === 'string') {
          res = JSON.parse(res)
        }
        if (res.data.code === 10001) {
          this.toIndex()
        } else if (res.data.code !== 10000) {
          this.$message.error(res.data.message)
        } else {
          this.$message.success(res.data.message)
          this.$router.go(-1)
        }
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    },
    getSiteBaseInfo(siteBaseId) {
      let _self = this
      _self.axios.get(
        _self.api.getSiteBaseInfoById + siteBaseId,
      ).then(res => {
        if (res.data.code === 10001) {
          this.toIndex()
        }
        this.siteBaseInfo = res.data.obj
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    },
    toIndex() {
      this.$router.push({
        path: '/index'
      })
    }, changeInfo_0(value) {
      if (value == 'open') {
        $("#siteNameChange").show();
      }
      if (value == 'close') {
        this.changeSiteBaseInfo.siteName = null
        $("#siteNameChange").hide();
        $("#afterContent_0").val("");
      }
    }, changeInfo_1(value) {
      if (value == 'open') {
        $("#companyNameChange").show();
      }
      if (value == 'close') {
        this.changeSiteBaseInfo.companyName = null
        $("#companyNameChange").hide();
        $("#afterContent_1").val("");
      }
    }, changeInfo_2(value) {
      if (value == 'open') {
        $("#siteTypeChange").show();
      }
      if (value == 'close') {
        this.changeSiteBaseInfo.siteType = null
        $("#siteTypeChange").hide();
        $("#afterContent_2").val("");
      }
    }, changeInfo_3(value) {
      if (value == 'open') {
        $("#applyNameChange").show();
      }
      if (value == 'close') {
        this.changeSiteBaseInfo.applyName = null
        $("#applyNameChange").hide();
        $("#afterContent_3").val("");
      }
    }, changeInfo_4(value) {
      if (value == 'open') {
        $("#applyEmailChange").show();
      }
      if (value == 'close') {
        this.changeSiteBaseInfo.applyEmail = null
        $("#applyEmailChange").hide();
        $("#afterContent_4").val("");
      }
    }, changeInfo_5(value) {
      if (value == 'open') {
        $("#applyPhoneChange").show();
        $("#getAuthCode").show();
      }
      if (value == 'close') {
        this.changeSiteBaseInfo.applyPhone = null
        $("#applyPhoneChange").hide();
        $("#getAuthCode").hide();
        $("#afterContent_5").val("");
        $("#authCode").val("");
      }
    }
  }
}
</script>

<style>
@import '../assets/css/iconfont.css';
@import '../assets/css/aicUser.css';
@import '../assets/css/newStyle.css';
@import '../assets/css/highlight.css';
@import '../assets/css/paging.css';
@import '../assets/css/bright.css';

#applyStatus .li {
  background: rgba(0, 0, 0, 0) none repeat scroll !important;
}

</style>




// WEBPACK FOOTER //
// src/components/changeSite.vue